;(function () {
  angular
    .module('contrast.analytics')
    .factory('csAnalyticsEventsService', csAnalyticsEventsService)

  function csAnalyticsEventsService($interpolate, csAnalyticsEvents) {
    'ngInject'

    return {
      getEvent: getEvent
    }

    function getEvent(eventKey, eventDiscriminator) {
      var event = _.clone(csAnalyticsEvents[eventKey])
      if (eventDiscriminator) {
        var action = $interpolate(event.action)
        var context = { discriminator: eventDiscriminator }
        event.action = action(context)
      }
      return event
    }
  }
})()
